import { render } from "./msgAgenda.vue?vue&type=template&id=090e3c06&scoped=true"
import script from "./msgAgenda.vue?vue&type=script&lang=js"
export * from "./msgAgenda.vue?vue&type=script&lang=js"

import "./msgAgenda.vue?vue&type=style&index=0&id=090e3c06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090e3c06"]])

export default __exports__